<template>
  <div>
    <table class="export_table" id="export_table">
      <tr>
        <th>순번</th>
        <th>가입번호</th>
        <th>11자리전화번호 <br>텍스트형식 <br>(EX. 01212345678)</th>
        <th>가입대리점코드</th>
        <th>사업자번호 <br>(120-82-00052)</th>
        <th>정지희망일 <br>(YYYYMMDD) <br>요청일자 표기</th>
        <th>해제희망일 <br>(YYYYMMDD) <br>무과금/미정인 경우 <br>99991231 표기</th>
      </tr>
      <tr :key="'excel_exp_' + index" v-for="(item, index) in list">
        <td>{{index + 1}}</td>
        <td>{{item.registryNum}}&#8203;</td>
        <td>{{item.mobileNum}}&#8203;</td>
        <td>{{item.dealershipCode}}&#8203;</td>
        <td>1208200052&#8203;</td>
        <td>{{item.regDateFormatted}}&#8203;</td>
        <td>99991231&#8203;</td>
      </tr>
    </table>
  </div>
</template>

<script>
import xlsx from 'xlsx/xlsx'
import common from '../../script/common'

export default {
  props: ['exportData', 'filter'],
  data () {
    return {
      ofcList: [],
      ofc1List: [],
      prtList: [],
      sttList: [],
      prgList: [],
      crsList: [],
      list: this.exportData,
      localFilter: this.filter
    }
  },
  mounted () {
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        let intervalCnt = 0
        let interval = setInterval(() => {
          if (common.checkValidateData('session', sessionStorage.getItem('ofcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('prtList')) &&
            common.checkValidateData('session', sessionStorage.getItem('sttList')) &&
            common.checkValidateData('session', sessionStorage.getItem('prgList')) &&
            common.checkValidateData('session', sessionStorage.getItem('crsList'))) {
            clearInterval(interval)
            this.ofcList = JSON.parse(sessionStorage.getItem('ofcList'))
            this.ofc1List = this.getOfc1List()
            this.prtList = JSON.parse(sessionStorage.getItem('prtList'))
            this.sttList = JSON.parse(sessionStorage.getItem('sttList'))
            this.prgList = JSON.parse(sessionStorage.getItem('prgList'))
            this.crsList = JSON.parse(sessionStorage.getItem('crsList'))
            this.$emit('prepared')
          } else if (intervalCnt > 10) {
            clearInterval(interval)
            common.amsAlert('retry', '필수 데이터를 불러오지 못했습니다.')
          } else {
            intervalCnt++
          }
        }, 200)
      } else {
        common.amsAlert('general', '로그아웃 되었습니다.\n다시 로그인해주세요.')
        this.$router.replace('/Login')
      }
    })
  },
  watch: {
    exportData (newVal) {
      this.list = newVal
    }
  },
  methods: {
    getOfc1List () {
      return this.ofcList.filter(item => { return item.codeLevel === 0 })
    },
    download () {
      // 새 워크북 생성
      let workBook = xlsx.utils.book_new()

      // 시트 데이터를 배열 형태로 정의
      let sheetData = [
        ['순번', '가입번호', '11자리전화번호 (텍스트형식) (EX. 01212345678)', '가입대리점코드', '사업자번호 (120-82-00052)', '정지희망일 (YYYYMMDD) 요청일자 표기', '해제희망일 (YYYYMMDD) 무과금/미정인 경우 99991231 표기']
      ]

      const today = common.getFormattedDate(new Date()).replaceAll('-', '')

      // 리스트 데이터를 순차적으로 배열에 추가
      this.list.forEach((item, index) => {
        console.log(`정지해제 엑셀 다운로드 아이템 ${index}`, item)
        let registryNum = { v: typeof item.registryNum === 'number' ? item.registryNum.toString() : item.registryNum, t: 's' } // 't: "s"'는 텍스트 형식을 지정
        let mobileNum = { v: typeof item.mobileNum === 'number' ? item.mobileNum.toString() : item.mobileNum, t: 's' } // 't: "s"'는 텍스트 형식을 지정
        let dealershipCode = { v: typeof item.dealershipCode === 'number' ? item.dealershipCode.toString() : item.dealershipCode, t: 's' } // 't: "s"'는 텍스트 형식을 지정
        sheetData.push([
          index + 1,
          registryNum,
          mobileNum,
          dealershipCode,
          '1208200052',
          '', // 정지희망일은 빈 값
          today
        ])
      })

      // 시트를 생성하고 워크북에 추가
      let workSheet = xlsx.utils.aoa_to_sheet(sheetData)
      xlsx.utils.book_append_sheet(workBook, workSheet, 'sheet1')

      // 파일명 생성 및 다운로드
      let strToday = common.getFormattedDate(Date.now()).replaceAll('-', '')
      xlsx.writeFile(workBook, '유플러스_회선관리_정지해제_' + strToday + '_' + this.localFilter.page + '.xlsx')
      // let mainData = xlsx.utils.table_to_sheet(document.getElementById('export_table'))
      // let workBook = xlsx.utils.book_new()
      // xlsx.utils.book_append_sheet(workBook, mainData, 'sheet1')
      // let strToday = common.getFormattedDate(Date.now()).replaceAll('-', '')
      // xlsx.writeFile(workBook, '유플러스_회선관리_정지해제_' + strToday + '_' + this.localFilter.page + '.xlsx')
    }
  }
}
</script>

<style scoped>
.export_table {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/excel/ExcelDownloadModemCancelExternal.vue